import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

export function getNavLinks(emit) {
  const emitNavEvent = (interactionRawText: string, optionSelected: string) =>
    emit(
      {
        eventAction: 'click' as const,
        interactionGoal: 'Navigate using the top menu',
        interactionName: 'menu_item_clicked',
        interactionRawText,
        optionSelected,
      },
      { isTentative: true }
    );

  return [
    {
      href: `${PLATFORM_MARKETING_BASE_URL}/how-to-build`,
      label: 'How to Build',
      onClick: () => emitNavEvent('How to Build', 'information'),
    },
    {
      href: `${PLATFORM_MARKETING_BASE_URL}/partner-program`,
      label: 'Partner Program',
      onClick: () => emitNavEvent('Partner Program', 'partners'),
    },
    {
      href: 'https://platform.zapier.com/docs',
      label: 'Documentation',
      onClick: () => emitNavEvent('Documentation', 'documentation'),
    },
    {
      href: '/contact',
      label: 'Help',
      onClick: () => emitNavEvent('Help', 'help'),
    },
  ];
}

export function getCtaLinks(emit) {
  const emitCtaEvent = (interactionRawText: string, optionSelected: string) =>
    emit(
      {
        eventAction: 'click' as const,
        interactionGoal: 'Navigate using the top menu',
        interactionName: 'menu_item_clicked',
        interactionRawText,
        optionSelected,
      },
      { isTentative: true }
    );

  return [
    {
      href: '/',
      label: 'My Integrations',
      onClick: () => emitCtaEvent('My Integrations', 'my integrations'),
    },
    {
      href: `${ZAPIER_APP_BASE_URL}/developer/zap-templates/`,
      label: 'Zap Templates',
      onClick: () => emitCtaEvent('Zap Templates', 'templates'),
    },
  ];
}

export function emitUserEventOptionClicked(
  emit,
  interactionGoal: string,
  interactionRawText: string,
  optionSelected: string
) {
  emit(
    {
      eventAction: 'click',
      interactionGoal,
      interactionName: 'profile_menu_option_clicked',
      interactionRawText,
      optionSelected,
    },
    { isTentative: true }
  );
}

export function getUserLinks(emit) {
  return [
    {
      href: '/partner-settings',
      label: 'Settings',
      onClick: () =>
        emitUserEventOptionClicked(
          emit,
          'Navigate to settings',
          'Settings',
          'settings'
        ),
    },
  ];
}
